var AttractionBehavior = require('./behaviors/AttractionBehavior');
var ConstantForceBehavior = require('./behaviors/ConstantForceBehavior');
var GravityBehavior = require('./behaviors/GravityBehavior');
    exports.AttractionBehavior = AttractionBehavior;
    exports.ConstantForceBehavior = ConstantForceBehavior;
    exports.GravityBehavior = GravityBehavior;




//////////////////
// WEBPACK FOOTER
// ./node_modules/toxiclibsjs/physics2d/behaviors.js
// module id = 4553
// module chunks = 13